import React, { useState, useEffect } from "react";
import backgroundVideo from "../assets/backgroundvideoai.mp4";
import {
  FaLinkedin,
  FaGithub,
  FaLaptopCode,
  FaWrench,
  FaCogs,
} from "react-icons/fa";
import ParticlesBackground from "../components/ParticlesBackground";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const ROLES = [
  "Full-Stack Developer",
  "Mobile App Developer",
  "DevOps Engineer",
  "Problem Solver",
];

function Home() {
  const navigate = useNavigate();

  // Typewriter state
  const [roleIndex, setRoleIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [typedText, setTypedText] = useState("");

  // Mouse spotlight state
  const [mouse, setMouse] = useState({ x: -9999, y: -9999 });

  // Typewriter effect
  useEffect(() => {
    const current = ROLES[roleIndex];
    if (!isDeleting && subIndex === current.length) {
      const pause = setTimeout(() => setIsDeleting(true), 2000);
      return () => clearTimeout(pause);
    }
    if (isDeleting && subIndex === 0) {
      setIsDeleting(false);
      setRoleIndex((prev) => (prev + 1) % ROLES.length);
      return;
    }
    const speed = isDeleting ? 45 : 95;
    const next = isDeleting ? subIndex - 1 : subIndex + 1;
    const timeout = setTimeout(() => {
      setSubIndex(next);
      setTypedText(current.slice(0, next));
    }, speed);
    return () => clearTimeout(timeout);
  }, [subIndex, isDeleting, roleIndex]);

  // Mouse spotlight
  useEffect(() => {
    const handle = (e) => setMouse({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handle);
    return () => window.removeEventListener("mousemove", handle);
  }, []);

  return (
    <div className="home-container">
      <video autoPlay loop muted className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
      </video>

      <ParticlesBackground />

      {/* Mouse spotlight */}
      <div
        className="mouse-spotlight"
        style={{
          background: `radial-gradient(380px circle at ${mouse.x}px ${mouse.y}px, rgba(0,255,200,0.055) 0%, transparent 100%)`,
        }}
      />

      <div className="hero-text">
        <h1 className="title">Samer Skayir</h1>

        <p className="subtitle">
          <span className="typed-text">{typedText}</span>
          <span className="cursor">|</span>
        </p>

        <p className="description">
          After 10+ years in education, I made a deliberate move into software development -
          bringing structure, communication, and a problem-solving mindset to every project.
          Today I build modern solutions with <strong>Java, Spring Boot, React</strong>, and more.
        </p>
        <p className="description">
          This portfolio is a snapshot of what I've built, what I know, and what I'm ready
          to deliver for your next project.
        </p>

        <div className="what-i-do">
          <h2 className="what-i-do-title">What I Do</h2>
          <div className="skills-grid">
            <div className="skill-card">
              <FaLaptopCode className="skill-icon" />
              <h4>Frontend</h4>
              <p>Building engaging interfaces with React, HTML, and CSS.</p>
            </div>
            <div className="skill-card">
              <FaWrench className="skill-icon" />
              <h4>Backend</h4>
              <p>Designing robust REST APIs with Java and Spring Boot.</p>
            </div>
            <div className="skill-card">
              <FaCogs className="skill-icon" />
              <h4>System Integration</h4>
              <p>Connecting services and databases for seamless functionality.</p>
            </div>
          </div>
        </div>

        <button className="cta-button" onClick={() => navigate("/projects")}>
          Explore My Projects
        </button>
      </div>

      <div className="social-links">
        <a
          href="https://linkedin.com/in/samer-skayir-23753b288"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaLinkedin size={38} />
        </a>
        <a
          href="https://github.com/SamerSkay"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaGithub size={38} />
        </a>
      </div>


    </div>
  );
}

export default Home;
